import React from 'react';
import { cn } from '../utils/cn';
export const Card = React.forwardRef(function Card(
  { variant = 'bordered', className, children, ...props },
  ref,
) {
  return (
    <div
      ref={ref}
      className={cn(
        'rounded-lg bg-surface',
        variant === 'bordered' && 'border border-edge-strong',
        variant === 'elevated' && 'shadow-md',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
});
export const CardHeader = React.forwardRef(function CardHeader(
  { className, children, ...props },
  ref,
) {
  return (
    <div
      ref={ref}
      className={cn(
        'flex items-center justify-between border-b border-edge-strong px-6 py-4',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
});
export const CardBody = React.forwardRef(function CardBody({ className, children, ...props }, ref) {
  return (
    <div ref={ref} className={cn('px-6 py-4', className)} {...props}>
      {children}
    </div>
  );
});
export const CardFooter = React.forwardRef(function CardFooter(
  { className, children, ...props },
  ref,
) {
  return (
    <div ref={ref} className={cn('border-t border-edge-strong px-6 py-4', className)} {...props}>
      {children}
    </div>
  );
});
